import { Datepicker } from 'components/form/Datepicker';
import { FormInput_text } from 'components/form/formInput/FormInput_text';
import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation, getObjectPropertyValue, isArrayNotEmpty, isDateValid, isFunction, isNumberOrStringValid, isStringTrimNotEmpty } from 'functions';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

export function useInvoiceGeneration(props) {
    const {
        selectedAccount,
        totalRequests,
        generateInvoice_requesting,

        // Functions
        generateInvoice = () => { },
        setAlertMsg = () => { },
    } = props;

    // States
    const [isModalVisible, setIsModalVisible] = useState();
    const [advancePayId, setAdvancePayId] = useState();
    const [companyId, setCompanyId] = useState();
    const [accountCode, setAccountCode] = useState();
    const [productCode, setProductCode] = useState();
    const [nextDateTime, setNextDateTime] = useState();
    const [documentDate, setDocumentDate] = useState();

    function createInvoice() {
        setAlertMsg([]);

        if (isArrayNotEmpty(selectedAccount)) {

            selectedAccount.map((accountDetails, idx) => {
                let advancePayId = getObjectPropertyValue(accountDetails, "Id");
                let comId = getObjectPropertyValue(accountDetails, "CompanyId");
                let accountCode = getObjectPropertyValue(accountDetails, "AccountCode");
                let productCode = getObjectPropertyValue(accountDetails, "ProductCode");
                let nextDateTime = getObjectPropertyValue(accountDetails, "NextBillDateTime");

                if (
                    // isNumberOrStringValid(advancePayId) &&
                    // isNumberOrStringValid(comId) &&
                    isStringTrimNotEmpty(accountCode) &&
                    // isStringTrimNotEmpty(productCode) &&
                    isDateValid(nextDateTime)) {

                    let obj = {
                        // id: advancePayId,
                        // comId,
                        accountCode,
                        // productCode,
                        dateBillDate: moment(nextDateTime).format("YYYY-MM-DD"), // Temporary trim
                        documentDate: isDateValid(documentDate) ? moment(documentDate).format("YYYY-MM-DD") : documentDate // Temporary trim
                    };

                    generateInvoice(obj);
                }
            });
        }
        else if (
            // isNumberOrStringValid(advancePayId) ||
            // isNumberOrStringValid(companyId) ||
            // isStringTrimNotEmpty(productCode) ||
            isStringTrimNotEmpty(accountCode) &&
            isDateValid(nextDateTime)) {

            let obj = {
                // id: advancePayId,
                // comId: companyId,
                accountCode,
                // productCode,
                dateBillDate: moment(nextDateTime).format("YYYY-MM-DD"), // Temporary trim
                documentDate: isDateValid(documentDate) ? moment(documentDate).format("YYYY-MM-DD") : documentDate // Temporary trim
            };

            generateInvoice(obj);
        }
        else {
            Toaster({
                type: "info",
                msg: "Account Code & Next Billed Date inputs are required.",
            });
        }
    }

    useEffect(() => {
        setAdvancePayId("");
        setCompanyId("");
        setAccountCode("");
        setProductCode("");
        setNextDateTime("");
        setDocumentDate("");
    }, [isModalVisible]);

    let generateInvoiceModal = (
        <ConfirmationModal
            description={"Generating advance pay invoice(s)"}
            input={(!isArrayNotEmpty(selectedAccount)) ? (
                <div className={"advance-pay-setup__generate-invoice"}>
                    {/* Advance Pay ID */}
                    {/* <FormInput_text  
                        inputLabel={"Commitment Pay ID"}

                        className={"generate-invoice__advance-pay-id"}
                        inputValue_default={advancePayId} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setAdvancePayId(value); }}

                        inputMaxLength={64}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                        isInputOptional
                    /> */}

                    {/* Company ID */}
                    {/* <FormInput_text  
                        inputLabel={"Company ID"}

                        className={"generate-invoice__company-id"}
                        inputValue_default={companyId} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setCompanyId(value); }}

                        inputMaxLength={64}

                        isInputValueTrim_onChange
                        isMarginBtmOptional isInputDigitOnly isConvertedToNumber
                        isInputOptional
                    /> */}

                    {/* Account Code */}
                    <FormInput_text
                        inputLabel={"Account Code"}

                        className={"generate-invoice__account-code"}
                        inputValue_default={accountCode}

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setAccountCode(value); }}

                        isInputValueTrim_onChange
                        isMarginBtmOptional
                    />

                    {/* Product Code */}
                    {/* <FormInput_text  
                        inputLabel={"Product Code"}

                        className={"generate-invoice__product-code"}
                        inputValue_default={productCode} 

                        isInputBlurHandlingRequired
                        handleInputBlurExtend={(value) => { setProductCode(value); }}

                        isInputValueTrim_onChange
                        isMarginBtmOptional
                        isInputOptional
                    /> */}

                    {/* Start Date Time */}
                    <Datepicker
                        className={"generate-invoice__start-date-time"}
                        inputClassName={"next-date-time__input"}

                        label={"Next Billed Date"}
                        dateFromParent={nextDateTime}
                        defaultDate={nextDateTime}
                        isResetRequired={isModalVisible}

                        handleOnChange={setNextDateTime}

                        isConversionRequired_ISO8601 isInputRequired
                    />

                    {/* Document Date Time */}
                    <Datepicker
                        className={"generate-invoice__document-date-time"}
                        inputClassName={"document-date-time__input"}

                        label={"Document Date"}
                        dateFromParent={documentDate}
                        defaultDate={documentDate}
                        isResetRequired={isModalVisible}

                        handleOnChange={setDocumentDate}

                        isConversionRequired_ISO8601
                    />
                </div>
            ) : (
                <Datepicker
                    className={"generate-invoice__document-date-time"}
                    inputClassName={"document-date-time__input"}

                    label={"Document Date"}
                    dateFromParent={documentDate}
                    defaultDate={documentDate}
                    isResetRequired={isModalVisible}
                    handleOnChange={setDocumentDate}

                    isConversionRequired_ISO8601
                />
            )}

            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={createInvoice}
            isActionLoading={generateInvoice_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );

    return {
        generateInvoiceModal,
        setIsModalVisible
    };
}